/** Before using this, check whether there's 'VITE_ENV' on Bitbucket => Repository Settings => Deployments Variables */
const isLogged = () => Boolean(sessionStorage.getItem('token'));

export default isLogged;
